const faqList = [
  {
    id: "1",
    title: "多拉打印可支持哪些打印方式？",
    content:
      "关注“多拉打印”公众号或小程序，即可通过微信公众号、微信小程序、U盘等移动端将需要打印的文件传输到附近任意的多拉打印终端，实现随时上传，就近取件。"
  },
  {
    id: "2",
    title: "使用多拉打印微信小程序如何打印？",
    content:
      "<p>1、在多拉打印微信小程序中选择“文档打印”或者“照片冲印”。</p><p>2、在“本地文档”或者“微信文档”中选择将要打印的文件。</p><p>3、在多拉打印微信小程序中完成打印设置，并完成支付。</p><p>4、在任意多拉打印终端上扫描屏幕或机身取件二维码, 选取订单进行打印。</p>"
  },
  {
    id: "3",
    title: "使用U盘如何打印？",
    content:
      "选择带屏幕且支持U盘打印的终端设备，将U盘插入U盘插口，在终端首页选择“U盘打印”，根据提示选择文件支付即可完成打印。"
  },
  {
    id: "4",
    title: "小程序打印失败，如何处理？",
    content:
      "微信小程序打印失败的订单，系统会自动回退到微信小程序中（小程序 => 订单 => 待打印列表），若需继续打印，可选择在附近任意多拉打印设备上重新扫码取件（点击查看附近终端）。若需退款，点击文件后面【退款】按钮即可完成退款。（因网络有延迟，如订单提示《打印中》请于1-30分钟后再次尝试即可）。"
  },
  {
    id: "5",
    title: "U盘打印失败，如何处理？",
    content:
      "微信关注“多拉打印”公众号，在对话框中直接留言 “U盘打印失败或质量问题”并发送，也可微信搜索“多拉打印”小程序，点击“我的” => “在线客服”留言，人工客服会在工作时间逐个回复处理退款事宜。（客服工作时间为：工作日09：30-18：30）。"
  },
  {
    id: "6",
    title: "打印显示成功，但效果不理想，如何处理？",
    content:
      "微信关注“多拉打印”公众号，在对话框中直接留言“如打印成功未出纸/打印墨浅/文件格式错乱等”并发送，也可微信搜索“多拉打印”小程序，点击“我的” => “在线客服”留言，人工客服会在工作时间逐个回复处理退款事宜。（客服工作时间为：工作日09：30-18：30）。"
  },
  {
    id: "7",
    title: "如何查看附近的其它多拉打印终端？",
    content:
      "在“多拉打印”微信小程序中点击首页的“附近终端”，即可查看所在位置附近的所有打印机终端。"
  },
  {
    id: "8",
    title: "搜索不到附近的多拉打印终端，如何处理？",
    content:
      "进入小程序，点击右上角三个…进入设置，点击位置信息，更改为“使用小程序时允许”即可。若还搜索不到，则该位置无设备终端。"
  },
  {
    id: "9",
    title: "如何参与多拉代理/合作？",
    content:
      "微信关注“多拉打印”公众号，在对话框中直接输入“代理”获取市场合作负责人的联系方式。也可微信搜索“多拉打印”小程序，点击“我的” => “招商加盟”或在线客服留言即可（客服工作时间为：工作日09：30-18：30）。"
  }
];

export { faqList };
